import React from 'react';
import auth from 'apis/auth';
import { CustomTagProps } from 'types/CustomTagProps';

export async function searchCollectionByName(
  name: string,
  setListOptions: React.Dispatch<React.SetStateAction<any[]>>,
) {
  await auth
    .get(
      `/bridge/vtex/api/catalog_system/pvt/collection/search/${name}?page=1&pageSize=10`,
    )
    .then((res: any) => {
      if (res.data.items && res.data.items.length > 0) {
        setListOptions(res.data.items);
      }
    })
    .catch(() => {
      setListOptions([]);
    });
}

export async function saveTag(tagToSave: CustomTagProps) {
  await auth
    .patch(`promotional-tags/${tagToSave.id}`, tagToSave)
    .then(() => {})
    .catch(() => {});
}
